<script setup lang="ts">
import { computed } from 'vue';
import { useQuasar } from 'quasar';

import type { AdminPageDto } from '@/services/types/api.types';
import { useAuthStore, useCommunityStore } from '@/stores';
import ReorderableTable from '@/components/ReorderableTable.vue';
import AdminEditDialog from '@/components/AdminEditDialog.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const $q = useQuasar();
const authStore = useAuthStore();
const communityStore = useCommunityStore();
const props = defineProps<{
  community_id: number;
}>();

const columns = computed(() => [
  {
    name: 'first_name',
    label: t('community.admins.firstName'),
    field: (row: AdminPageDto) => row.User.first_name,
    align: 'left',
  },
  {
    name: 'last_name',
    label: t('community.admins.lastName'),
    field: (row: AdminPageDto) => row.User.last_name,
    align: 'left',
  },
  { name: 'email', label: t('community.admins.email'), field: (row: AdminPageDto) => row.User.email, align: 'left' },
]);

const community = computed(() => communityStore.communities.find((c) => c.id === props.community_id));
const actionMenuItems = computed(() => [
  {
    action: 'delete',
    label: t('global.label.delete'),
    disabled: (row: any) => row.user_id === authStore.user?.id,
  },
]);

const handleAddRow = () => {
  const admin = 'admin@cocoriko.org';
  $q.dialog({
    component: AdminEditDialog,
    componentProps: {
      mode: 'add',
      email: admin,
      communityId: props.community_id,
    },
  });
};

const handleActions = (action: any) => {
  if (action.action === 'delete') {
    $q.dialog({
      title: t('community.dialogs.deleteAdminTitle'),
      message: t('community.dialogs.deleteAdminMessage'),
      cancel: true,
      persistent: true,
    }).onOk(async () => {
      await communityStore.removeAdmin(community.value!.id, action.payload.row);
    });
  }
};
</script>

<template>
  <div>
    <reorderable-table
      :rows="community.admins"
      :columns="columns"
      :title="$t('community.tabs.admins')"
      itemKey="id"
      :disableOrderable="true"
      :disableDeleteButton="true"
      :action-menu-items="actionMenuItems"
      @add-row="handleAddRow"
      @actions="handleActions"
    />
  </div>
</template>
